var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 350,
    viewBox: "0 0 298 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4543 330.343C-1.40357 312.981-15.6447 260.276 31.6434 212.612 78.9315 164.949 169.837 140.386 234.695 157.748 299.553 175.109 313.794 227.815 266.506 275.478 219.218 323.142 128.312 347.705 63.4543 330.343z",
    fill: "#a2eaf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.069 281.392C216.063 259.189 240.377 224.582 229.375 204.095 218.373 183.608 176.222 184.999 135.227 207.202 94.2326 229.405 69.9189 264.012 80.9209 284.499 91.9228 304.986 134.074 303.595 175.069 281.392z",
    fill: "#6edfee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.499 218.059C222.696 208.248 235.536 201.847 249.974 198.078 264.228 194.351 266.783 185.543 257.338 182.684 246.628 179.442 233.264 185.4 224.643 193.682 209.623 208.115 207.742 219.162 207.742 219.162L214.499 218.059z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M214.499 218.059C222.696 208.248 235.536 201.847 249.974 198.078 264.228 194.351 266.783 185.543 257.338 182.684 246.628 179.442 233.264 185.4 224.643 193.682 209.623 208.115 207.742 219.162 207.742 219.162L214.499 218.059z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27 217.483C210.212 217.483 210.145 217.466 210.087 217.441 209.879 217.34 209.796 217.09 209.896 216.881 222.062 191.81 248.982 185.643 255.531 186.111 255.764 186.127 255.93 186.328 255.913 186.562 255.897 186.796 255.68 186.963 255.464 186.946 249.073 186.453 222.619 192.571 210.636 217.249 210.578 217.399 210.428 217.483 210.27 217.483z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.73 220.667C207.73 222.438 209.644 223.516 211.167 222.622 218.79 218.168 229.907 215.703 247.906 220.842 257.476 223.575 262.186 221.745 264.2 217.834 266.438 213.488 261.695 209.285 256.286 207.304 237.871 200.543 221.253 205.156 207.73 218.644V220.667z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.779 221.026C208.662 221.026 208.554 220.976 208.471 220.884 208.321 220.708 208.329 220.449 208.504 220.29 224.406 206.017 249.038 208.8 258.358 214.365 258.558 214.482 258.624 214.741 258.499 214.942 258.383 215.143 258.125 215.201 257.925 215.084 248.788 209.627 224.648 206.919 209.053 220.917 208.978 220.984 208.879 221.026 208.779 221.026z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.474 277.092C98.6887 272.07 78.1489 274.899 57.8471 282.151 37.7899 289.318 27.5624 280.889 36.5151 269.792 46.6586 257.207 67.4661 253.423 84.4978 256.283 114.196 261.261 125.441 272.904 125.441 272.904L116.474 277.092z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M116.474 277.092C98.6887 272.07 78.1489 274.899 57.8471 282.151 37.7899 289.318 27.5624 280.889 36.5151 269.792 46.6586 257.207 67.4661 253.423 84.4978 256.283 114.196 261.261 125.441 272.904 125.441 272.904L116.474 277.092z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.051 272.971C121.122 272.925 121.186 272.853 121.234 272.779 121.398 272.492 121.295 272.117 121.007 271.952 86.0476 251.967 48.8805 266.534 41.4579 272.418 41.1963 272.63 41.1547 273.003 41.3679 273.265 41.5811 273.528 41.972 273.555 42.2155 273.359 49.4444 267.564 86.001 253.322 120.417 272.995 120.622 273.121 120.872 273.095 121.051 272.971z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.028 272.287C127.146 275.39 125.253 279.621 121.535 280.078 109.345 281.614 94.9831 288.249 78.8691 307.615 69.6807 318.662 62.5711 320.315 56.9727 317.3 50.7565 313.944 52.9977 305.065 57.8317 298.299 74.2986 275.261 97.9049 267.224 125.028 272.287z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.713 275.983C125.856 275.891 125.951 275.744 125.971 275.566 126.019 275.236 125.783 274.929 125.444 274.888 94.8318 270.819 67.6965 294.194 61.1075 308.42 60.9683 308.718 61.0978 309.086 61.4049 309.218 61.703 309.359 62.07 309.231 62.2012 308.924 68.6602 294.987 95.2611 272.079 125.288 276.081 125.449 276.101 125.597 276.069 125.713 275.983z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.796 72.7519 216.671 72.6767C216.663 72.6767 216.663 72.6683 216.654 72.6683L184.933 54.3332C184.925 54.3248 184.916 54.3248 184.9 54.3165L184.716 54.2246V54.2329C169.896 46.7284 150.124 48.9764 128.863 62.7904 86.1404 90.5354 53.5785 154.399 56.1415 205.427 57.423 230.865 67.1841 248.306 81.9464 255.969V255.978L82.0795 256.044C82.0878 256.044 82.0878 256.053 82.0962 256.053L113.826 274.396C113.834 274.396 113.834 274.405 113.843 274.405L114.001 274.488V274.48C128.821 282.009 148.61 279.761 169.896 265.947 212.618 238.202 245.18 174.339 242.617 123.311 241.319 97.8645 231.558 80.4235 216.796 72.7519z",
    fill: "#ffb154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.735 273.812 82.0954 256.045C82.0704 256.045 82.0704 256.045 82.0704 256.045L81.9289 255.961C67.175 248.273 57.4139 230.832 56.1407 205.427 55.0007 182.671 60.8506 157.374 71.4439 133.875L71.6602 133.357 103.182 152.21C92.5638 175.701 86.7304 200.998 87.8704 223.762 89.1187 248.666 98.497 265.889 112.735 273.812z",
    fill: "#fca947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 265.939C212.602 238.194 245.164 174.33 242.593 123.303 240.03 72.2753 203.316 53.397 160.593 81.142 117.871 108.887 85.309 172.751 87.872 223.778 90.4433 274.806 127.158 293.684 169.88 265.939z",
    fill: "#ffc654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.782 197.231 167.043 205.589C164.049 206.642 154.7 200.264 154.708 197.102L154.894 117.681C154.896 116.046 155.53 114.458 156.659 112.926 157.787 111.395 159.291 110.472 160.838 110.001L179.299 104.395C180.812 103.935 182.235 103.927 183.211 104.801 184.188 105.672 184.655 106.986 184.494 108.646L176.613 189.522C176.292 192.757 173.733 196.194 170.782 197.231z",
    fill: "#f5a84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54 214.188C157.367 210.437 161.214 207.687 166.071 205.938 171.078 204.136 174.804 204.113 177.265 205.863 179.72 207.606 180.811 211.096 180.544 216.334 180.286 221.384 178.764 225.791 175.971 229.561 173.171 233.34 169.332 236.153 164.437 237.998 159.634 239.808 155.943 239.792 153.373 237.935 150.797 236.074 149.633 232.638 149.888 227.633 150.154 222.431 151.705 217.95 154.54 214.188z",
    fill: "#f5a84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.784 197.524 168.033 205.738C165.039 206.792 158.702 200.557 158.71 197.394L158.896 117.974C158.898 116.338 159.531 114.75 160.661 113.218 161.789 111.687 163.293 110.765 164.84 110.294L183.301 104.688C184.814 104.227 186.237 104.22 187.213 105.093 188.19 105.965 192.718 109.178 192.557 110.838L180.615 189.814C180.294 193.05 177.735 196.486 174.784 197.524z",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5 116.501l5 5V205C162.9 205 160.167 200.667 159 198.5V117L159.5 116.501z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.438 215.164C161.265 211.413 165.113 208.663 169.97 206.914 174.976 205.112 178.702 205.089 181.164 206.839 183.619 208.582 189.123 213.28 188.856 218.518 188.598 223.568 186.56 231.678 183.767 235.448 180.967 239.228 174.733 242.116 169.838 243.961 165.035 245.771 160.272 242.465 157.703 240.609 155.127 238.748 153.532 233.614 153.787 228.609 154.052 223.407 155.604 218.926 158.438 215.164z",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.602 202.18 168.857 205.961C165.863 207.015 163.52 205.213 163.528 202.051L163.714 122.63C163.717 120.994 164.35 119.406 165.48 117.875 166.607 116.343 168.111 115.421 169.658 114.95L188.119 109.344C189.633 108.884 191.055 108.876 192.031 109.75 193.008 110.621 193.476 111.934 193.314 113.595l-7.881 80.875C185.113 197.706 182.554 201.142 179.602 202.18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.298 219.556C166.125 215.806 169.972 213.056 174.829 211.307 179.836 209.504 183.562 209.482 186.023 211.232 188.478 212.975 189.569 216.465 189.302 221.703 189.044 226.753 187.522 231.159 184.729 234.93 181.929 238.709 178.089 241.522 173.195 243.367 168.391 245.177 164.7 245.161 162.131 243.304 159.555 241.443 158.391 238.007 158.646 233.002 158.911 227.8 160.463 223.319 163.298 219.556z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 274.191,
    y1: 200.324,
    x2: 194.055,
    y2: 200.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 276.403,
    y1: 213.507,
    x2: 193.585,
    y2: 213.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 116.51,
    y1: 239.72,
    x2: 35.589,
    y2: 310.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 130.16,
    y1: 252.926,
    x2: 41.1576,
    y2: 330.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h298v350H0z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertWarning);
export default __webpack_public_path__ + "static/media/ico-alert-warning.cfcbfed98f7842c6ff28cee12f5a5beb.svg";
export { ForwardRef as ReactComponent };